import { render, staticRenderFns } from "./G11PresupuestoVsRealXAreaXCecoYCuentaMayor.vue?vue&type=template&id=1bf819c3&"
import script from "./G11PresupuestoVsRealXAreaXCecoYCuentaMayor.vue?vue&type=script&lang=js&"
export * from "./G11PresupuestoVsRealXAreaXCecoYCuentaMayor.vue?vue&type=script&lang=js&"
import style0 from "./G11PresupuestoVsRealXAreaXCecoYCuentaMayor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VDataTable,VDivider,VTextField,VToolbar,VToolbarTitle})
